var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.521 4.6623L19.7501 9.15732C20.0541 9.78304 20.8647 10.3832 21.5486 10.4982L25.5888 11.175C28.1725 11.6091 28.7804 13.4991 26.9186 15.3635L23.7777 18.5304C23.2457 19.0668 22.9544 20.1011 23.1191 20.8418L24.0183 24.7622C24.7276 27.8653 23.0937 29.0656 20.3707 27.4439L16.5838 25.1836C15.8999 24.7749 14.7727 24.7749 14.0761 25.1836L10.2892 27.4439C7.57879 29.0656 5.9323 27.8525 6.64156 24.7622L7.54079 20.8418C7.70544 20.1011 7.41414 19.0668 6.8822 18.5304L3.74121 15.3635C1.89208 13.4991 2.48735 11.6091 5.07106 11.175L9.11128 10.4982C9.78254 10.3832 10.5931 9.78304 10.8971 9.15732L13.1262 4.6623C14.342 2.22324 16.3178 2.22324 17.521 4.6623Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewStar);
export default __webpack_public_path__ + "static/media/preview_star.87edf18950d6495c1037ed0d0382abb8.svg";
export { ForwardRef as ReactComponent };